(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeatureCardsSwiper(root) {
      var wrap = root ? root.querySelector('.t4s-feature-cards__swiper-wrap') : null;
      var el = wrap ? wrap.querySelector('[data-fc-swiper]') : null;
      if (!el || !el.dataset.fcSwiperConfig) return;

      var run = function () {
        if (typeof Swiper === 'undefined') {
          setTimeout(run, 50);
          return;
        }

        if (el.swiper) {
          el.swiper.destroy(true, true);
        }

        var config = JSON.parse(el.dataset.fcSwiperConfig);
        var colMb = parseFloat(config.colMb) || 1;
        var colTb = parseInt(config.colTb, 10) || 2;
        var colDk = parseInt(config.colDk, 10) || 5;
        var spaceMb = parseInt(config.spaceMb, 10) || 10;
        var spaceDk = parseInt(config.spaceDk, 10) || 20;
        var slideCount = el.querySelectorAll('.swiper-slide').length;
        var paginationEl = el.querySelector('.t4s-feature-cards__pagination');
        var prevEl = wrap.querySelector('.t4s-feature-cards__nav--prev');
        var nextEl = wrap.querySelector('.t4s-feature-cards__nav--next');

        var swiperConfig = {
          slidesPerView: colMb,
          spaceBetween: spaceMb,
          watchOverflow: true,
          loop: config.loop && slideCount > colMb,
          grabCursor: true,
          breakpoints: {
            768: {
              slidesPerView: colTb,
              spaceBetween: spaceDk,
              allowTouchMove: false,
              grabCursor: false,
              loop: false
            },
            1024: {
              slidesPerView: colDk,
              spaceBetween: spaceDk,
              allowTouchMove: false,
              grabCursor: false,
              loop: false
            }
          }
        };

        if (config.pagination && paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            clickable: true
          };
        }

        if (config.navigation && prevEl && nextEl) {
          swiperConfig.navigation = {
            prevEl: prevEl,
            nextEl: nextEl
          };
        }

        if (config.autoplay > 0) {
          swiperConfig.autoplay = {
            delay: config.autoplay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
          swiperConfig.breakpoints[768].autoplay = false;
          swiperConfig.breakpoints[1024].autoplay = false;
        }

        new Swiper(el, swiperConfig);
      };

      run();
    }

    function initAll() {
      document.querySelectorAll('.t4s-feature-cards').forEach(initFeatureCardsSwiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('t4s-feature-cards') || event.target.querySelector('.t4s-feature-cards')) {
        initFeatureCardsSwiper(event.target.classList.contains('t4s-feature-cards') ? event.target : event.target.querySelector('.t4s-feature-cards'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-videos-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRvGridSwiper(root) {
      var wrap = root ? root.querySelector('.t4s-rv-grid__swiper-wrap') : null;
      var el = wrap ? wrap.querySelector('[data-rvg-swiper]') : null;
      if (!el || !el.dataset.rvgSwiperConfig) return;

      var header = root ? root.querySelector('.t4s-rv-grid__header') : null;
      var prevEl = header ? header.querySelector('.t4s-rv-grid__nav--prev') : null;
      var nextEl = header ? header.querySelector('.t4s-rv-grid__nav--next') : null;

      var run = function () {
        if (typeof Swiper === 'undefined') {
          setTimeout(run, 50);
          return;
        }

        if (el.swiper) {
          el.swiper.destroy(true, true);
        }

        var config = JSON.parse(el.dataset.rvgSwiperConfig);
        var colMb = parseFloat(config.colMb) || 1.2;
        var colTb = parseFloat(config.colTb) || 2;
        var colDk = parseFloat(config.colDk) || 3;
        var spaceMb = parseInt(config.spaceMb, 10) || 12;
        var spaceDk = parseInt(config.spaceDk, 10) || 24;
        var slideCount = el.querySelectorAll('.swiper-slide').length;
        var paginationEl = el.querySelector('.t4s-rv-grid__pagination');

        var swiperConfig = {
          slidesPerView: colMb,
          spaceBetween: spaceMb,
          watchOverflow: true,
          loop: config.loop && slideCount > Math.ceil(colMb),
          grabCursor: true,
          breakpoints: {
            768: {
              slidesPerView: colTb,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colTb)
            },
            1024: {
              slidesPerView: colDk,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colDk)
            }
          }
        };

        if (config.pagination && paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            clickable: true
          };
        }

        if (config.navigation && prevEl && nextEl) {
          swiperConfig.navigation = {
            prevEl: prevEl,
            nextEl: nextEl
          };
        }

        if (config.autoplay > 0) {
          swiperConfig.autoplay = {
            delay: config.autoplay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
        }

        new Swiper(el, swiperConfig);
      };

      run();
    }

    function initAll() {
      document.querySelectorAll('.t4s-related-videos-grid').forEach(initRvGridSwiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('t4s-related-videos-grid') || event.target.querySelector('.t4s-related-videos-grid')) {
        initRvGridSwiper(event.target.classList.contains('t4s-related-videos-grid') ? event.target : event.target.querySelector('.t4s-related-videos-grid'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRelatedVideosSwiper(root) {
      var wrap = root ? root.querySelector('.t4s-related-videos__swiper-wrap') : null;
      var el = wrap ? wrap.querySelector('[data-rv-swiper]') : null;
      if (!el || !el.dataset.rvSwiperConfig) return;

      var run = function () {
        if (typeof Swiper === 'undefined') {
          setTimeout(run, 50);
          return;
        }

        if (el.swiper) {
          el.swiper.destroy(true, true);
        }

        var config = JSON.parse(el.dataset.rvSwiperConfig);
        var colMb = parseFloat(config.colMb) || 1.2;
        var colTb = parseFloat(config.colTb) || 2.5;
        var colDk = parseFloat(config.colDk) || 4.5;
        var spaceMb = parseInt(config.spaceMb, 10) || 12;
        var spaceDk = parseInt(config.spaceDk, 10) || 20;
        var slideCount = el.querySelectorAll('.swiper-slide').length;
        var paginationEl = el.querySelector('.t4s-related-videos__pagination');
        var prevEl = wrap.querySelector('.t4s-related-videos__nav--prev');
        var nextEl = wrap.querySelector('.t4s-related-videos__nav--next');

        var swiperConfig = {
          slidesPerView: colMb,
          spaceBetween: spaceMb,
          watchOverflow: true,
          loop: config.loop && slideCount > Math.ceil(colMb),
          grabCursor: true,
          breakpoints: {
            768: {
              slidesPerView: colTb,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colTb)
            },
            1024: {
              slidesPerView: colDk,
              spaceBetween: spaceDk,
              loop: config.loop && slideCount > Math.ceil(colDk)
            }
          }
        };

        if (config.pagination && paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            clickable: true
          };
        }

        if (config.navigation && prevEl && nextEl) {
          swiperConfig.navigation = {
            prevEl: prevEl,
            nextEl: nextEl
          };
        }

        if (config.autoplay > 0) {
          swiperConfig.autoplay = {
            delay: config.autoplay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
        }

        new Swiper(el, swiperConfig);
      };

      run();
    }

    function initAll() {
      document.querySelectorAll('.t4s-related-videos').forEach(initRelatedVideosSwiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('t4s-related-videos') || event.target.querySelector('.t4s-related-videos')) {
        initRelatedVideosSwiper(event.target.classList.contains('t4s-related-videos') ? event.target : event.target.querySelector('.t4s-related-videos'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
